import { render, staticRenderFns } from "./rolemodal.vue?vue&type=template&id=6b39035f&"
import script from "./rolemodal.vue?vue&type=script&lang=js&"
export * from "./rolemodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports